module.exports = __webpack_public_path__ + "img/notifications-icon-orange.2c26b553.svg";